import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { AuthManagerService } from './auth/auth-manager.service';
import * as Cookies from "js-cookie";
import { User } from './auth/auth.model';
import { optimistic } from './api/common-http.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'hecht-angular-web';

  private readonly cookieName = "AuthToken";
  
  isLoadUser: boolean = false;

  constructor(private translateService: TranslateService, private authManagerService: AuthManagerService) {
    this.translateService.use(environment.defaultLocale);
  }

  ngOnInit(): void {
    this.init();
  }

  init(): any {
    let token = Cookies.get(this.cookieName);
    if (token) {
      this.authManagerService.isLoggedIn = false;
      this.authManagerService.isRecovering = true;
      this.authManagerService.isSigningIn = false;
      this.authManagerService.authRequest<User>("GET", "/current-user", null, null, token).pipe(optimistic).subscribe(user => {
        this.authManagerService.currentUser = user;
        this.authManagerService.token = token;
        this.authManagerService.isLoggedIn = true;
        this.authManagerService.isRecovering = false;
        this.authManagerService.isSigningIn = false;
        this.isLoadUser = true;
      });
    } else {
      this.isLoadUser = true;
    }
  }
}
